var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Facebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 2.66663C8.63633 2.66663 2.66699 8.63596 2.66699 16C2.66699 23.364 8.63633 29.3333 16.0003 29.3333C23.3643 29.3333 29.3337 23.364 29.3337 16C29.3337 8.63596 23.3643 2.66663 16.0003 2.66663Z",
    fill: "url(#paint0_linear_686_14791)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.805 19.534H21.2557L21.7977 16.0287H17.805V14.1127C17.805 12.6567 18.281 11.3654 19.643 11.3654H21.8317V8.30669C21.447 8.25469 20.6337 8.14136 19.097 8.14136C15.8877 8.14136 14.0064 9.83602 14.0064 13.6974V16.0294H10.707V19.5347H14.0057V29.1694C14.659 29.2667 15.321 29.3334 16.0004 29.3334C16.6144 29.3334 17.2137 29.2774 17.805 29.1974V19.534Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_686_14791",
    x1: 6.66233,
    y1: 6.66196,
    x2: 27.077,
    y2: 27.0766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AA4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Facebook);
export default __webpack_public_path__ + "static/media/icons8-facebook.2d8542ca6ff9adfb53a3ac5f74ff497a.svg";
export { ForwardRef as ReactComponent };